import { useState, useEffect, useRef } from "react";
import { Row, Col, Button, Form, Alert, ButtonGroup, Modal, ProgressBar } from "react-bootstrap";

import DateTimePicker from "react-datetime-picker";
import { MultiSelect } from "react-multi-select-component";

import moment from "moment";
import _ from "lodash";
import axios from "axios";
import Utils from "./../../common/Utils";

const ToDoForm = (props) => {
  const refAssignedTo = useRef(0);

  const [selAssTo, setSelAssTo] = useState([]);
  const [modes, setModes] = useState({
    dd: new Date(),
    ne: 1,
    occ: 1,
    priority: 1,
    ed: null,
  });
  const [adding, setAdding] = useState(false);
  const [tass, setTass] = useState({
    loading: false,
    data: [],
    perpage: 5,
    start: 0,
    total: 0,
  });

  const fetchTasksAssigned = (start = 0) => {
    const assto = selAssTo.map((s) => parseInt(s.value)).join(",");
    const pvals = {
      mode: 4,
      start: start,
      perpage: tass.perpage,
      assigned_to: assto,
    };

    setTass({ ...tass, loading: true, total: 0 });

    axios
      .get(Utils.apiUrl("tasks/fetchtasks?") + Utils.postVars(pvals), Utils.apiHeaders())
      .then((res) => {
        setTass({
          ...tass,
          loading: false,
          start: pvals.start,
          total: res.data.total,
          data: res.data.tasks,
        });
      })
      .catch((err) => console.log(err.message));
  };

  useEffect(fetchTasksAssigned, [selAssTo]);

  const saveTask = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    const assto = selAssTo.map((s) => parseInt(s.value)).join(",");

    if (frm.task.value === "") {
      window.alert("Task name cannot be left blank!");
    } else if (modes.occ > 1 && modes.ed === null) {
      window.alert("Select End date for this repeating task!");
      //return false;
    } else if (modes.occ > 1 && moment(modes.ed).isBefore(moment(modes.dd))) {
      window.alert("Please send end date correctly!");
      //return false;
    } else if (modes.occ > 1 && moment(modes.dd).isValid() && moment().isAfter(moment(modes.dd).endOf("day"))) {
      window.alert("Invalid date selected!");
      //setModes({...modes,dd:new Date()});
      //return false;
    } else if (assto === "") {
      window.alert("Please select user to assign the task!");
    } else {
      const pvals = {
        name: frm.task.value,
        due_on: moment(modes.dd).utcOffset(0).format("YYYY-MM-DD HH:mm:00"),
        occurance: modes.occ,
        ends_on: moment(modes.ed).utcOffset(0).format("YYYY-MM-DD 23:59:59"),
        priority: modes.priority === 1,
        require_evidence: modes.ne === 1,
        assigned_to: assto,
      };

      setAdding(true);
      axios
        .post(Utils.apiUrl("tasks/add"), Utils.postVars(pvals), Utils.apiHeaders())
        .then((res) => {
          setAdding(false);
          if (res.data.success) {
            props.onHide();
            props.onAdd();
          } else {
            window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const showPagination = () => {
    return (
      <div className="d-flex flex-row-reverse">
        {tass.start + tass.perpage >= tass.total && (
          <div className="text-disabled ms-2">
            <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
          </div>
        )}
        {tass.start + tass.perpage < tass.total && (
          <div className="clickable ms-2 text-clickable" onClick={() => fetchTasksAssigned(tass.start + tass.perpage)}>
            <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
          </div>
        )}
        {tass.start > 0 && (
          <div className="clickable text-clickable" onClick={() => fetchTasksAssigned(tass.start - tass.perpage)}>
            Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
          </div>
        )}
        {tass.start === 0 && (
          <div className="text-disabled">
            Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
          </div>
        )}
      </div>
    );
  };

  const renderMultiSelect = (opts) => {
    const udata = Utils.getUserData();
    let data = [{ label: "Myself", value: udata.uid }];

    opts.map((tm) => {
      data.push({ label: `${tm.title} ${tm.name}`, value: tm.id });
    });

    return <MultiSelect options={data} value={selAssTo} ref={refAssignedTo} name="assigned_to" onChange={setSelAssTo} />;
  };

  return (
    <Modal show={props.show} size="lg" backdrop="static" onHide={props.onHide}>
      <Form onSubmit={saveTask} noValidate>
        <Modal.Header closeButton>
          <Modal.Title>Create a Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {adding && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Creating task, please wait..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}

          {!adding && (
            <>
              <Row className="mb-3">
                <Col xs="3" className="fw-bold">
                  Task
                </Col>
                <Col>
                  <Form.Control name="task" placeholder="Put your task here.." required={true}></Form.Control>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs="3" className="fw-bold">
                  Due Date and Time
                </Col>
                <Col>
                  <div className="d-flex flex-row">
                    <DateTimePicker
                      disableClock={true}
                      minDate={moment().add(15, "m").toDate()}
                      clearIcon={null}
                      format="y-MM-dd"
                      onChange={(v) => setModes({ ...modes, dd: v })}
                      value={modes.dd}
                    />
                    <div className="d-flex flex-row">
                      <select
                        className="form-select ms-3"
                        value={modes.dd.getHours()}
                        onChange={(ele) => {
                          let t = new Date(modes.dd);
                          t.setHours(ele.target.value);
                          setModes({ ...modes, dd: new Date(t) });
                        }}
                      >
                        {_.fill(new Array(24), 0).map((v, idx) => (
                          <option key={idx} value={idx}>
                            {idx < 10 ? 0 : ""}
                            {idx} Hours
                          </option>
                        ))}
                      </select>

                      <select
                        className="form-select ms-1"
                        onChange={(ele) => {
                          let t = new Date(modes.dd);
                          t.setMinutes(ele.target.value);
                          setModes({ ...modes, dd: new Date(t) });
                        }}
                        value={modes.dd.getMinutes()}
                      >
                        {_.fill(new Array(60), 0).map((v, idx) => (
                          <option key={idx} value={idx}>
                            {idx < 10 ? 0 : ""}
                            {idx} Mins
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs="3" className="fw-bold">
                  Need Evidence
                </Col>
                <Col>
                  <ButtonGroup aria-label="Basic example" className="shadow btn-group">
                    <Button variant={modes.ne === 1 ? "primary" : "light"} onClick={() => setModes({ ...modes, ne: 1 })} className="radius-left">
                      YES
                    </Button>
                    <Button variant={modes.ne === 0 ? "primary" : "light"} onClick={() => setModes({ ...modes, ne: 0 })} className="radius-right">
                      NO
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs="3" className="fw-bold">
                  Occurrence
                </Col>
                <Col>
                  <ButtonGroup aria-label="Basic example" className="shadow btn-group">
                    <Button variant={modes.occ === 1 ? "primary" : "light"} onClick={() => setModes({ ...modes, occ: 1 })} className="radius-left">
                      Once
                    </Button>
                    <Button variant={modes.occ === 2 ? "primary" : "light"} onClick={() => setModes({ ...modes, occ: 2 })}>
                      Daily
                    </Button>
                    <Button variant={modes.occ === 3 ? "primary" : "light"} onClick={() => setModes({ ...modes, occ: 3 })}>
                      Weekly
                    </Button>
                    <Button variant={modes.occ === 4 ? "primary" : "light"} onClick={() => setModes({ ...modes, occ: 4 })} className="radius-right">
                      Monthly
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              {modes.occ > 1 && (
                <Row className="mb-3">
                  <Col xs="3" className="fw-bold">
                    Ends on
                  </Col>
                  <Col>
                    <DateTimePicker
                      minDate={modes.dd}
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yyyy"
                      clearIcon={null}
                      format="y-MM-dd"
                      onChange={(v) => setModes({ ...modes, ed: v })}
                      value={modes.ed}
                    />
                  </Col>
                </Row>
              )}
              <Row className="mb-3">
                <Col xs="3" className="fw-bold">
                  Priority
                </Col>
                <Col>
                  <ButtonGroup aria-label="Basic example" className="shadow btn-group">
                    <Button
                      variant={modes.priority === 1 ? "primary" : "light"}
                      onClick={() => setModes({ ...modes, priority: 1 })}
                      className="radius-left"
                    >
                      High
                    </Button>
                    <Button
                      variant={modes.priority === 0 ? "primary" : "light"}
                      onClick={() => setModes({ ...modes, priority: 0 })}
                      className="radius-right"
                    >
                      Low
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs="3" className="fw-bold">
                  Assign To
                </Col>
                <Col>{renderMultiSelect(_.get(props, "orgMembers", []))}</Col>
              </Row>

              {tass.loading && (
                <Alert variant="warning" className="p-3">
                  <p className="loading-msg">Loading task, please wait..</p>
                  <ProgressBar variant="warning" animated now={100} />
                </Alert>
              )}

              {_.get(tass, "total", 0) > 0 && (
                <>
                  <table className="table table-striped mb-3">
                    <thead>
                      <tr>
                        <th>Task Name</th>
                        <th>Assigned by</th>
                        <th width="100">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tass.data.map((ta, idx) => (
                        <tr key={idx}>
                          <td>{ta.name}</td>
                          <td>{ta.uname}</td>
                          <td>{moment(ta.due_on).format("DD/MM/YYYY")}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {tass.total > tass.perpage && showPagination()}
                </>
              )}
            </>
          )}
        </Modal.Body>
        {!adding && (
          <Modal.Footer className="d-flex justify-content-center">
            <Button variant="secondary" onClick={props.onHide}>
              Close
            </Button>
            <Button type="submit" variant="primary">
              Submit
            </Button>
          </Modal.Footer>
        )}
      </Form>
    </Modal>
  );
};

export default ToDoForm;
